/**
 * 跨 feature 的编译时常量。
 * 仅放真正跨 feature 的；feature 私有常量放在 features/<name>/constants.ts。
 */

export const BROADCAST_CHANNELS = {
  AUTH: "flowable-admin:auth",
  PREFS: "flowable-admin:prefs",
} as const;

export const STORAGE_KEYS = {
  PREFERENCES: "flowable-admin:preferences",
  UI: "flowable-admin:ui",
  RECENT: "flowable-admin:recent",
  FAVORITES: "flowable-admin:favorites",
} as const;
